import React, { FC } from 'react'

import { HorizontalAlignment, useIsTabletOrMobile } from '@avantstay/backoffice-core'

import { DatePickerBasedFilter } from '@new/__global/components/Filters/FiltersVariations/DatePicker'
import { FilterRenderingComponentProps } from '@new/__global/components/FiltersFramework'
import { filtersLabels } from '@new/domains/bookings/screens/bookingsList/utils/labels'

import { FILTERS_DATE_FORMAT } from '../../config/contants'

export const ViewFromFilter: FC<FilterRenderingComponentProps<string>> = ({
  activeValue,
  label,
  onChange,
  isSidebarFilter,
  isAccordionOpen,
}) => {
  const isTabletOrMobile = useIsTabletOrMobile()

  return (
    <DatePickerBasedFilter
      title={filtersLabels.viewFrom}
      initialValue={activeValue}
      singleDateRangeFormat={FILTERS_DATE_FORMAT}
      singleDateRange
      onChange={onChange}
      labelInternal={label}
      clearButtonLabel={isTabletOrMobile ? 'Reset' : 'Clear'}
      horizontalAlignment={isTabletOrMobile ? HorizontalAlignment.Right : HorizontalAlignment.Left}
      inputWidthMaxContent
      isSidebarFilter={isSidebarFilter}
      isAccordionOpen={isAccordionOpen}
    />
  )
}
